// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3FhFp","overflowing":"ReadFullNote_overflowing__i60bl"};